import { FiX } from "react-icons/fi";

export default function DeleteDocModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete",
  message = "Are you sure you want to delete this?",
}) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={onClose} // 👈 clicking outside closes
    >
      <div
        className="bg-white dark:bg-bg-dark dark:border dark:border-gray-200 rounded-lg  max-w-md w-full mx-4 relative "
        onClick={(e) => e.stopPropagation()} // 👈 prevent closing when clicking inside
      >
        {/* Icon (absolute & centered) */}
        <div className="absolute left-1/2 -translate-x-1/2 -top-8 bg-white p-1.5 rounded-full">
          <div className="w-16 h-16 bg-indigo-900 dark:bg-bg-dark rounded-full flex items-center justify-center ">
            <FiX className="w-8 h-8 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center mb-8 mt-20">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            {title}
          </h2>
          <p className="text-gray-600 dark:text-gray-300 text-base">
            {message}
          </p>
        </div>

        {/* Buttons */}
        <div className="flex gap-3  w-full p-5 rounded-b-lg bg-bg-DeleteBtnBg">
          <button
            onClick={onClose} // 👈 Cancel closes modal
            className="flex-1 px-6 py-3 bg-bg-light dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg font-medium hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-6 py-3 bg-bg-dark dark:bg-indigo-700 text-white rounded-lg font-medium hover:bg-indigo-800 dark:hover:bg-indigo-600 transition-colors"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
